import { Outlet } from 'react-router-dom';

import '@/assets/css/blue.css';
import '@/assets/css/bootstrap.css';
import '@/assets/css/medicom.css';
import '@/assets/css/revolution_style.css';
import '@/assets/css/settings.css';
import GlobeLoading from '@/components/GlobeLoading';
import useLocale from '@/locales/hooks/useLocale';
import { getCookie } from '@/utilities/cookies';
import moment from 'moment';
import 'moment/dist/locale/de';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/tr';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Footer from './footer';
import Header from './header';


const Layout = () => {
  const dispatch = useDispatch();

  const {
    setLocale
  } = useLocale();

  useEffect(() => {
    const locale = getCookie('locale');
    if (locale) {
      setLocale(locale);
    }
    else {
      setLocale('tr');
    }
  }, []);

  const {locale} = useLocale();
  useEffect(() => {  
    switch (locale) {
      case 'tr':
        moment.locale('tr');
        break;
      case 'us':
        moment.locale('en-gb');
        break;
      case 'de':
        moment.locale('de');
        break;
      default:
        moment.locale('en-gb');
        break;
    }
  }, [locale]);
 
  return (
    <div id="wrapper" className="clearfix">
      <GlobeLoading
        
      />
      <Header 
      />
      <div id="content-index">
        <Outlet />
      </div>
      <Footer 
      />
      <a href="#"
        onClick={() => {
          document.scrollingElement?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="back-to-top" id="back-to-top"><i className="fa fa-angle-up"></i></a>
    </div>
  );
};

export default Layout;
